export default "__VITE_ASSET__CNkZcyH0__"